import "./StripedBar.scss";

export function StripedBar(props: { text: string }) {
  return (
    <div className="striped-bar">
      <span className="bar-text">{props.text}</span>
    </div>
  );
}
